import { useQuery } from "@tanstack/react-query";
import { FieldSetsByCategoryAPI } from "api";

const fetchData = (categoryId) => {
  return FieldSetsByCategoryAPI.get({ params: { categoryId } });
};

export const useFetchFieldSetsByCategory = (enabled, categoryId) => {
  return useQuery({
    queryKey: ["fieldSets-by-category", categoryId],
    queryFn: () => fetchData(categoryId),
    enabled,

    // ✅ CACHING OPTIONS
    staleTime: 5 * 60 * 1000, // 5 minutes → data considered fresh
    cacheTime: 30 * 60 * 1000, // 30 minutes → keep in cache
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
